import React from 'react'

function OurModelPage() {
  return (
    <div>OurModelPage</div>
  )
}

export default OurModelPage